import React from "react";
import DOMPurify from "isomorphic-dompurify";
import {
  DiscountBannerIcon,
  DiscountBannerText,
  DiscountBannerSubtitle,
  DiscountBannerTitle,
  DiscountBannerWrapper,
  DiscountBannerWrapperSlideUp
} from "./styles";
import { useContext } from "react";
import { Context } from "@components/useContext/context";
import { resolvePath } from "@utils/resolvePath";

const DiscountBanner = (props: any) => {
  const {
    icon,
    iconAlt,
    heading,
    strikeOffHeading,
    subheading,
    strikeOffPrice,
    styles,
    slideUpEntrance,
    stackedReveal
  } = props;
  const { isDesktop } = useContext(Context);

  const headingTemplate =
    strikeOffHeading && Number(strikeOffPrice) > 0 ? strikeOffHeading : heading;
  const title = headingTemplate || "";
  const subtitle = subheading || "";

  const isTitleOnly = Boolean(title) && !subtitle;
  const desktopStyles: React.CSSProperties | undefined = isDesktop
    ? {
        maxWidth: "550px",
        margin: "0 auto"
      }
    : undefined;

  const layoutStyles = (() => {
    const s = { ...(styles || {}) } as React.CSSProperties;
    if (stackedReveal) {
      delete s.position;
      delete s.bottom;
      delete s.left;
      delete s.right;
      delete s.zIndex;
      delete s.transform;
      s.width = "100%";
      s.maxWidth = "100%";
      s.boxSizing = "border-box";
    }
    if (slideUpEntrance && isDesktop && s.transform !== undefined) {
      delete s.transform;
    }
    return stackedReveal
      ? { ...s, width: "100%", boxSizing: "border-box" as const }
      : { ...desktopStyles, ...s };
  })();

  const inner = (
    <>
      {icon ? (
        <DiscountBannerIcon
          src={resolvePath("/images/icons/increase_insuarance_price.svg")}
          alt={iconAlt || "discount"}
        />
      ) : null}
      <DiscountBannerText isTitleOnly={isTitleOnly} $isDesktop={isDesktop}>
        {title ? (
          <DiscountBannerTitle
            $isDesktop={isDesktop}
            $hasStrikeOff={Boolean(
              strikeOffHeading && Number(strikeOffPrice) > 0
            )}
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(title)
            }}
          />
        ) : null}
        {subtitle ? (
          <DiscountBannerSubtitle
            $isDesktop={isDesktop}
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(subtitle)
            }}
          />
        ) : null}
      </DiscountBannerText>
    </>
  );

  if (stackedReveal) {
    return (
      <DiscountBannerWrapper style={layoutStyles}>{inner}</DiscountBannerWrapper>
    );
  }
  return slideUpEntrance ? (
    <DiscountBannerWrapperSlideUp $isDesktop={isDesktop} style={layoutStyles}>
      {inner}
    </DiscountBannerWrapperSlideUp>
  ) : (
    <DiscountBannerWrapper style={layoutStyles}>{inner}</DiscountBannerWrapper>
  );
};

export default DiscountBanner;
